import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SUIT_MARK, completeWelcome, updateName, useSession } from '../lib/session';

/**
 * Artboard 1c — shown once, after a first sign-in.
 * Two jobs: get a name that will read well under a photograph in the gallery,
 * and hand over the team. The team is treated as a moment rather than a form
 * field — it is the only purely delightful screen in the whole site.
 */
export default function Welcome() {
  const session = useSession();
  const navigate = useNavigate();
  const [name, setName] = useState(session?.name ?? '');

  if (!session) return null;

  function go() {
    updateName(name);
    completeWelcome();
    navigate('/now', { replace: true });
  }

  return (
    <div className="auth">
      <div className="auth-col">
        <h2 style={{ margin: '0 0 4px' }}>You're in, {session.name.split(' ')[0]}</h2>
        <p style={{ fontSize: 13, opacity: 0.7, margin: '0 0 18px' }}>
          Signed in as <strong>{session.email}</strong> — use that address if you come back on another phone.
        </p>

        <div className="field" style={{ marginBottom: 20 }}>
          <label htmlFor="displayName">Your name, as it will show on your photos</label>
          <input
            id="displayName" className="input" style={{ minHeight: 50, fontSize: 16 }}
            value={name} onChange={(e) => setName(e.target.value)} autoComplete="name"
          />
        </div>

        <div className="reveal">
          <div className="reveal-mark" aria-hidden="true">{SUIT_MARK[session.team]}</div>
          <div className="reveal-blob" aria-hidden="true" />
          <div style={{ position: 'relative' }}>
            <div className="reveal-kicker">Your team</div>
            <div className="reveal-name">{session.team}</div>
            <p>Teams play the welcome dinner game on Thursday. Nothing to do until then.</p>
          </div>
        </div>

        <button type="button" className="btn btn-primary btn-block" style={{ minHeight: 54, fontSize: 16, margin: '18px 0 16px' }} onClick={go}>
          Take me to the schedule
        </button>
      </div>
    </div>
  );
}
